import { render, staticRenderFns } from "./product-delivery-item.vue?vue&type=template&id=1f3e341f&"
import script from "./product-delivery-item.vue?vue&type=script&lang=js&"
export * from "./product-delivery-item.vue?vue&type=script&lang=js&"
import style0 from "./product-delivery-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3e341f')) {
      api.createRecord('1f3e341f', component.options)
    } else {
      api.reload('1f3e341f', component.options)
    }
    module.hot.accept("./product-delivery-item.vue?vue&type=template&id=1f3e341f&", function () {
      api.rerender('1f3e341f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-delivery-item.vue"
export default component.exports